export function parseTaskDate(value) {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

function isCompletedStatus(task) {
    return String(task?.status || "").toLowerCase() === "completed";
}

export function isOverdue(task) {
    const due = parseTaskDate(task.due_date);
    if (!due || isCompletedStatus(task)) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDay = new Date(due);
    dueDay.setHours(0, 0, 0, 0);
    return dueDay.getTime() < today.getTime();
}

export function isDueToday(task) {
    const due = parseTaskDate(task.due_date);
    if (!due || isCompletedStatus(task)) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDay = new Date(due);
    dueDay.setHours(0, 0, 0, 0);
    return dueDay.getTime() === today.getTime();
}

export function isDueTodayOrOverdue(task) {
    if (isCompletedStatus(task)) return false;
    const due = parseTaskDate(task.due_date);
    if (!due) return true;
    return isDueToday(task) || isOverdue(task);
}

const PRIORITY_ORDER = { high: 0, medium: 1, low: 2 };

export function sortTasksForStaff(tasks) {
    return [...tasks].sort((a, b) => {
        const pa = PRIORITY_ORDER[a.priority?.toLowerCase()] ?? 1;
        const pb = PRIORITY_ORDER[b.priority?.toLowerCase()] ?? 1;
        if (pa !== pb) return pa - pb;
        const da = parseTaskDate(a.due_date)?.getTime() ?? Infinity;
        const db = parseTaskDate(b.due_date)?.getTime() ?? Infinity;
        return da - db;
    });
}

export function formatDueLabel(task) {
    const due = parseTaskDate(task.due_date);
    if (!due) return null;
    if (isCompletedStatus(task)) {
        return due.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDay = new Date(due);
    dueDay.setHours(0, 0, 0, 0);
    const diffDays = Math.round((today.getTime() - dueDay.getTime()) / 86400000);
    if (diffDays === 0) return "Due Today";
    if (diffDays === 1) return "1 Day Overdue";
    if (diffDays > 1 && diffDays < 7) return `${diffDays} Days Overdue`;
    if (diffDays === 7) return "1 Week Overdue";
    if (diffDays > 7) {
        const weeks = Math.max(1, Math.round(diffDays / 7));
        return weeks === 1 ? "1 Week Overdue" : `${weeks} Weeks Overdue`;
    }
    return due.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

export function isOverdueDueLabel(label) {
    return String(label || "").includes("Overdue");
}
